import "@fortawesome/fontawesome-free/css/all.min.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Loader from "../../components/Loader";

const ContentManagement = () => {
  const [isLoading, setIsLoading] = useState(false);

  const [pages, setPages] = useState([]);

  //other page data
  const [otherPages, setOtherPages] = useState([]);

  //pricing page data
  const [pricingPages, setPricingPages] = useState([]);

  //how-it-works page data
  const [howItWorksPages, setHowItWorksPages] = useState([]);

  //testimonial page data
  const [testimonialPages, setTestimonialPages] = useState([]);

  const fetchPages = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/pages/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response", response);
      setPages(response?.data?.data);
    } catch (error) {
      console.error("Error fetching pages:", error);
    } finally {
      setIsLoading(false);
    }
  };

  //other page data
  const fetchOtherPages = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/other-pages/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response", response);
      setOtherPages(response?.data?.data);
    } catch (error) {
      console.error("Error fetching other-pages:", error);
    } finally {
      setIsLoading(false);
    }
  };

  //pricing page data
  const fetchPricingPages = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/pricing/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response", response);
      setPricingPages(response?.data?.data);
    } catch (error) {
      console.error("Error fetching other-pages:", error);
    } finally {
      setIsLoading(false);
    }
  };

  //how-it-works page data
  const fetchHowItWorksPages = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/how-it-works/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response", response);
      setHowItWorksPages(response?.data?.data);
    } catch (error) {
      console.error("Error fetching other-pages:", error);
    } finally {
      setIsLoading(false);
    }
  };

  //pricing page data
  const fetchTestimonialPages = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/testimonial/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response", response);
      setTestimonialPages(response?.data?.data);
    } catch (error) {
      console.error("Error fetching other-pages:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPages();
    fetchOtherPages();
    fetchPricingPages();
    fetchHowItWorksPages();
    fetchTestimonialPages();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">Content Management</h1>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Page Name</th>
                          <th>Slug</th>
                          {/* <th>Description</th> */}
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pages.map((data, index) => (
                          <tr key={index}>
                            <td>{data?.name}</td>
                            <td>{data?.slug}</td>
                            {/* <td>{truncateText(stripHtmlTags(data.description), 100)}</td> */}
                            <td>
                              <Link
                                to={`/content-management-update/${data?._id}`}
                                className="btn btn-link merch-edit"
                              >
                                <i className="fas fa-edit"></i>
                              </Link>
                            </td>
                          </tr>
                        ))}
                        {otherPages.map((data, index) => (
                          <tr key={`other-${index}`}>
                            <td>{data?.name}</td>
                            <td>{data?.slug}</td>
                            {/* <td>{truncateText(stripHtmlTags(data.description), 100)}</td> */}
                            <td>
                              <Link
                                to={`/content-management-update-other/${data?._id}`}
                                className="btn btn-link merch-edit"
                              >
                                <i className="fas fa-edit"></i>
                              </Link>
                            </td>
                          </tr>
                        ))}

                        {pricingPages.map((data, index) => (
                          <tr key={`other-${index}`}>
                            <td>{data?.name}</td>
                            <td>{data?.slug}</td>
                            {/* <td>{truncateText(stripHtmlTags(data.description), 100)}</td> */}
                            <td>
                              <Link
                                to={`/content-management-pricing-page/${data?._id}`}
                                className="btn btn-link merch-edit"
                              >
                                <i className="fas fa-edit"></i>
                              </Link>
                            </td>
                          </tr>
                        ))}

                        {howItWorksPages.map((data, index) => (
                          <tr key={`other-${index}`}>
                            <td>{data?.name}</td>
                            <td>{data?.slug}</td>
                            {/* <td>{truncateText(stripHtmlTags(data.description), 100)}</td> */}
                            <td>
                              <Link
                                to={`/content-management-how-it-works/${data?._id}`}
                                className="btn btn-link merch-edit"
                              >
                                <i className="fas fa-edit"></i>
                              </Link>
                            </td>
                          </tr>
                        ))}

                        {testimonialPages.map((data, index) => (
                          <tr key={`other-${index}`}>
                            <td>{data?.name}</td>
                            <td>{data?.slug}</td>
                            {/* <td>{truncateText(stripHtmlTags(data.description), 100)}</td> */}
                            <td>
                              <Link
                                to={`/content-management-testimonial/${data?._id}`}
                                className="btn btn-link merch-edit"
                              >
                                <i className="fas fa-edit"></i>
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentManagement;
